@if (vip$.store.nextVipUserLevel?.LevelName) {
  @if (vip$.store.isShowProgressBar) {
    <div class="button bonuses__action_locked">
      <i class="icon-lock"></i>
      <div class="content">
        <span class="link" routerLink="/profile/deposit">{{ 't.earn' | translate }} </span>
        <span class="spacer">{{ vip$.store.nextVipUserLevel?.VPointsToReach - vip$.store.nextVipUserLevel?.TotalReward }} </span>
        <img src="/assets/img/vip/points.png" class="logo" />
        <span class="spacer">{{ 't.diamonds-to-unlock' | translate }}</span>
        <app-vip-level-label [levelName]="vip$.store.nextVipUserLevel?.LevelName"></app-vip-level-label>
      </div>
    </div>
  }
} @else {
  <div class="max-level">{{'t.vip-max-level-reach' | translate}}</div>
}
